import React, { useState, useContext, useEffect } from 'react';
import { Body, Header, Main } from '../NecttosComp/Layout/Layout';
import { Table, Tbody, Td, Th, Thead, Tr } from '../NecttosComp/Table/Table';
import Button from '../NecttosComp/Button/Button';
import axios from 'axios';
import Input2 from '../NecttosComp/Input/Input2';
import { NecttosContext } from '../context/NecttosContext';

const Busconcession = ({ userId, onClose, refectData, parentOnClose, startDateTimer, TimerFunction, toast }) => {
	const [travelList, setTravelList] = useState([]);
	const [filterMinDistance, setFilterMinDistance] = useState(0);
	const [loading, setLoading] = useState(false);
	const [classOptions, setClassOptions] = useState([{ _id: '', className: 'All Classes' }]);

	const { collegeId } = useContext(NecttosContext);
	const [state, setState] = useState({ classId: '' });

	useEffect(() => {
		const fetchClasses = async () => {
			try {
				const { data } = await axios.get(`college/action/getClasses`, {
					params: { collegeId },
				});

				if (data && data.list) {
					const fetchedOptions = data.list.map((classItem) => ({
						_id: classItem.classId || '',
						className: classItem.className || 'Unknown Class',
					}));

					setClassOptions([{ _id: '', className: 'All Classes' }, ...fetchedOptions]);
				}
			} catch (error) {
				console.error('Error fetching classes:', error);
				setClassOptions([{ _id: '', className: 'All Classes' }]);
			}
		};

		if (collegeId) {
			fetchClasses();
		}
	}, [collegeId]);

	useEffect(() => {
		const fetchTravelData = async () => {
			setLoading(true);
			try {
				const { data } = await axios.post('college/admissionProcess2/getTravelDetails', {
					classId: state.classId || '',
					collegeId: collegeId,
				});
				
				if (data.status === 'success') {
					const filteredData = data.data.filter((user) => {
						const kmValue = parseInt(user.km) || 0;
						return kmValue >= filterMinDistance;
					});
					setTravelList(filteredData);
				} else {
					toast?.error('Failed to fetch travel details');
				}
			} catch (err) {
				console.error('Error fetching travel details', err);
				toast?.error('Error fetching travel details');
			} finally {
				setLoading(false);
			}
		};

		if (classOptions.length > 0 && collegeId) {
			fetchTravelData();
		}
	}, [state.classId, filterMinDistance, toast, classOptions.length, collegeId]);

	const handleResetFilters = () => {
		setState({ classId: '' });
		setFilterMinDistance(0);
	};

	return (
		<Main width='100%' height='100%' title='Bus concession'>
			<Header>
				<Button type='reset' onClick={handleResetFilters}>
					Reset Filters
				</Button>
				<Input2 
					type='drop' 
					returnKey='classId' 
					className='w-[470px]' 
					optionDisplay='className' 
					optionKey='_id' 
					fieldName='Select Class' 
					options={classOptions} 
					state={state} 
					setState={setState} 
					didntShowKey 
				/>
				<Button type='close' onClick={onClose}>
					Close
				</Button>
			</Header>

			<Body>
				<Table height='100%' width='100%' className='rounded-lg shadow-md overflow-hidden'>
					<Thead>
						<Tr className='bg-gray-100'>
							<Th width='10%' className='py-3 px-4'>
								Class
							</Th>
							<Th width='10%' className='py-3 px-4'>
								Travel Distance (km)
							</Th>
							<Th width='10%' className='py-3 px-4'>
								Name
							</Th>
							<Th width='10%' className='py-3 px-4'>
								Mobile
							</Th>
							<Th width='10%' className='py-3 px-4'>
								Action
							</Th>
						</Tr>
					</Thead>
					<Tbody>
						{loading ? (
							<div className='m-5 p-5 flex justify-center items-center'>
								<span>Loading...</span>
							</div>
						) : travelList.length === 0 ? (
							<div className='m-5 p-5 flex justify-center items-center'>
								<p>No travel details found matching your filters</p>
							</div>
						) : (
							travelList.map((user, index) => (
								<Tr key={user.id || user._id || index} className='hover:bg-gray-50 border-b border-gray-200'>
									<Td width='10%' className='py-3 px-4'>
										{user.class || 'No Class'}
									</Td>
									<Td width='10%' className='py-3 px-4'>
										{user.km}
									</Td>
									<Td width='10%' className='py-3 px-4'>
										{user.name || 'Unknown Name'}
									</Td>
									<Td width='10%' className='py-3 px-4'>
										{user.phoneNumber || 'No Phone Number'}
									</Td>
									<Td width='10%' className='py-3 px-4'>
									</Td>
								</Tr>
							))
						)}
					</Tbody>
				</Table>
			</Body>
		</Main>
	);
};

export default Busconcession;